import { Component, OnInit } from "@angular/core";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { MatDialogRef } from "@angular/material/dialog";
import Swal, { SweetAlertType } from "sweetalert2";

@Component({
  selector: "app-cropped-dialog",
  templateUrl: "./cropped-dialog.component.html",
  styleUrls: ["./cropped-dialog.component.scss"]
})
export class CroppedDialogComponent implements OnInit {
  ratio: number;

  constructor(public dialogRef: MatDialogRef<CroppedDialogComponent>) {}

  ngOnInit() {
    if (!this.ratio) {
      this.ratio = 4 / 4;
    }
  }

  alert(title: string, icon: SweetAlertType) {
    Swal.fire({
      type: icon,
      title: title,
      showConfirmButton: false,
      timer: 2500
    });
  }

  base64ToFile(data: string, filename: string) {
    const arr = data.split(",");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: "image/jpeg" });
  }

  imageChangedEvent: any = "";
  pdfChangedEvent: any = false;
  croppedImageFile: FormData | File | string = "";
  croppedImageBase: any = "";
  showCropped: boolean = false;

  fileChangeEvent(file: File[]): void {
    this.showCropped = true;
    let fileSize = file[0].size;
    let fileType = file[0].type;
    const maxFileSize = 15000000;

    if (
      fileType !== "application/pdf" &&
      fileType !== "text/csv" &&
      fileType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      fileType !== "application/vnd.ms-excel"
    ) {
      this.imageChangedEvent = event;
      this.pdfChangedEvent = false;
    } else {
      this.pdfChangedEvent = event;
      this.imageChangedEvent = false;
      this.croppedImageBase = null;
    }

    if (
      fileType !== "image/png" &&
      fileType !== "image/jpeg" &&
      fileType !== "application/pdf" &&
      fileType !== "text/csv" &&
      fileType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      fileType !== "application/vnd.ms-excel"
    ) {
      this.alert("Formato de arquivo não permitido", "error");
      this.dialogRef.close();
    } else if (fileSize > maxFileSize) {
      this.alert("Arquivo excede o tamanho de 15mb", "error");
      this.dialogRef.close();
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageBase = event.base64;
    const fileName = this.fileNameParser(this.imageChangedEvent.target.files[0].name);
    this.croppedImageFile = this.base64ToFile(event.base64, fileName);
  }

  fileNameParser(filename: string) {
    let text: string = "";
    for (let i = 0; i < filename.length; i++) {
      if (filename[i] === " ") {
        continue;
      }
      text += filename[i];
    }
    return text;
  }

  closeCropped() {
    this.showCropped = false;
  }

  close() {
    if (!this.pdfChangedEvent) {
      this.dialogRef.close({
        croppedImageFile: this.croppedImageFile,
        croppedImageBase: this.croppedImageBase,
        file: this.imageChangedEvent
      });
    } else {
      let formData = new FormData();
      formData.append("files", this.pdfChangedEvent.target.files[0]);

      this.dialogRef.close({
        croppedImageFile: formData.get("files"),
        croppedImageBase: this.pdfChangedEvent.base64,
        file: this.pdfChangedEvent
      });
    }
  }
}
